import Cssjs from './css';

import { unEscapeCssSequence } from './unescapeCssSequences';
const parser = new Cssjs();
export const parseMSOCss = (cssString: any) => {
    if (!cssString) {
        console.error('invalid css string');
        return [];
    }
    const parsed = parser.parseCSS(cssString);
    // console.log(parsed);
    return parsed;
};
const parseRules = (cssString: any) => {
    if (!cssString) {
        // console.error('invalid css string');
        return [];
    }
    const parsed = parser.parseRules(cssString);
    // console.log(parsed);
    return parsed;
};
export default class MSOStyle {
    public styleSheetsParsed: any;
    public constructor(styleSheetsHTMLStr: any) {
        const styleSheetsParsed = parseMSOCss(styleSheetsHTMLStr);
        this.styleSheetsParsed = this.transform(styleSheetsParsed);
        this.getComputedStyle = this.getComputedStyle.bind(this);
    }
    public transform(array: any) {
        return array.reduce((obj: any, item: any) => {
            obj[item.selector] = (obj[item.selector] || []).concat(item.rules);
            return obj;
        }, {});
    }
    public getComputedStyle(dom: any) {
        if (!dom.getAttribute) {
            return {};
        }
        let className = dom.getAttribute('class');
        let styleString = dom.getAttribute('style');
        let mergedStyle = this.getMergedStyles(className, styleString, dom);
        if (Object.keys(mergedStyle).length === 0 && dom.tagName.toLowerCase() === 'span' && dom.parentNodeText) {
            // 尝试获取一次父node，解决纯文本自己创建的span取不到属性的问题
            const parentNode = dom.parentNodeText;
            className = parentNode.getAttribute('class');
            styleString = parentNode.getAttribute('style');
            mergedStyle = this.getMergedStyles(className, styleString, parentNode);
        }
        return mergedStyle;
    }
    public getMergedStyles(className: any, styleString: any, dom: any) {
        const classParsedRules = this.getRulesBySelector(`.${className}`);
        const domParsedRules = this.parseRules(styleString);
        let domTagParsedRules = [];
        if (dom.tagName) {
            domTagParsedRules = this.getRulesBySelector(dom.tagName.toLowerCase());
        }
        const domTagStyles = domTagParsedRules ? domTagParsedRules : [];
        const classStyles = classParsedRules ? classParsedRules : [];

        const tempArray: any = domTagStyles.concat(classStyles);
        const mergedStyle = this.getMergeStyles(tempArray.concat(domParsedRules));
        return mergedStyle;
    }
    public getMergeStyles(array: ({directive: string;value: string})[]) {
        // 提升性能 reduce改成forEach
        const obj: any = {};
        array.forEach((item: {directive: string;value: string}) => {
            let { value } = item;
            if (/mso/.test(item.directive)) {
                // 提升性能 必要时候进行正则替换
                value = unEscapeCssSequence(item.value);
            }
            obj[item.directive] = value;
        });
        return obj;
    }
    public parseRules(styleString: any) {
        return parseRules(styleString);
    }
    public getRulesBySelector(selector: any) {
        return this.styleSheetsParsed[selector];
    }
}
